import {FC} from 'react';
import {Box, FormControl} from '@mui/material';
import PhoneInput from 'react-phone-input-2';
import {useIntl} from 'react-intl';
import {FormHelper} from '../FormHelper';
import {CustomFormLabel} from '../CustomFormLabel';
import {phoneDefaultCountry, phonePlaceholder, phonePreferredCountries} from '../../../utils/consts';
import {AMPPhoneNumberProps} from './AMPPhoneNumber.types';
import {inputBoxSx, inputSx} from './AMPPhoneNumber.sx';
import countryNamesDe from 'react-phone-input-2/lang/de.json';
import countryNamesFr from 'react-phone-input-2/lang/fr.json';
import 'react-phone-input-2/lib/style.css';

/** The library ships its own country names; English is its default, so only these two are needed. */
const countryNames: Record<string, object> = {de: countryNamesDe, fr: countryNamesFr};

export const AMPPhoneNumber: FC<AMPPhoneNumberProps> = ({
                                                            hasError,
                                                            helperText,
                                                            label,
                                                            value,
                                                            onChange,
                                                            ...rest
                                                        }) => {
    const intl = useIntl();

    return (
        <FormControl
            fullWidth
            variant="outlined"
            error={!!hasError}
            margin="normal"
        >
            <CustomFormLabel
                label={intl.formatMessage({id: label})}
                required={rest.required}
            />
            <Box sx={inputBoxSx(!!hasError)}>
                <PhoneInput
                    placeholder={phonePlaceholder}
                    inputStyle={inputSx}
                    value={value}
                    country={phoneDefaultCountry}
                    preferredCountries={phonePreferredCountries}
                    enableSearch
                    searchPlaceholder={intl.formatMessage({id: 'search'})}
                    searchNotFound={intl.formatMessage({id: 'noResultsFound'})}
                    localization={countryNames[intl.locale]}
                    onChange={onChange}
                    {...rest}
                />
            </Box>
            {helperText && <FormHelper helperText={helperText}/>}
        </FormControl>
    );
};
